module.exports = __webpack_public_path__ + "media/images/hero-banner-ff44cc384fb9b645f343e5597aca79b2.png";